import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
  TableContainer,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const BankDetails = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={8} xs={12}>
            Bank Transfer Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={12} xs={12}>
          <TableContainer className="common_X_scroll">
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Receiving Bank Account</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["receiving_bank"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Transaction Mode</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {data["transaction_payment_mode"]}
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Virtual Account Number</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["virtual_account_number"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">UTR Number</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["utr_number"]} </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Customer Ref Id</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["customer_ref_id"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Partner</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["partner"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Partner Txn Id</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["partner_txn_id"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                  <TableBodyCell className="common_table_title">Credentials Of</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["credentials_of"]}</TableBodyCell>
              </TableBody>
              {/* <TableBody>
                <TableBodyCell>Remitter Account Ifsc</TableBodyCell>
                <TableBodyCell>{data["remitter_account_ifsc"]}</TableBodyCell>
              </TableBody> */}
              {/* <TableBody>
                <TableBodyCell>Remitter Account Type</TableBodyCell>
                <TableBodyCell>{data["remitter_account_type"]}</TableBodyCell>
              </TableBody> */}
            </table>
            </TableContainer>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
          <TableContainer className="common_X_scroll">
            <table className="w-full">
              {/* <TableBody>
                <TableBodyCell>Remitter Full Name</TableBodyCell>
                <TableBodyCell>{data["remitter_full_name"]}</TableBodyCell>
              </TableBody> */}
              <TableBody>
                <TableBodyCell className="common_table_title">Payer Vpa</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["payer_vpa"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Status</TableBodyCell>
                <TableBodyCell>
                  <BootstrapBadge text={data["status"]} />
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">comment</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Expired At</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["expired_at"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Mobile No.</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["mobile_number"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Is Manually Created</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["is_manually_applied"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {readableFormatDate(data["created_at"])}
                </TableBodyCell>
              </TableBody>
            </table>
            </TableContainer>  
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
